import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Image from "react-bootstrap/Image";
import Card from "react-bootstrap/Card";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Formik } from "formik";
import * as yup from "yup";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
function loginUser(credentials) {
    return _loginUser.apply(this, arguments);
}
function _loginUser() {
    _loginUser = _async_to_generator(function(credentials) {
        return _ts_generator(this, function(_state) {
            return [
                2,
                fetch("/json/login.json", {
                    method: "GET"
                }).then(function(data) {
                    return data.json();
                })
            ];
        });
    });
    return _loginUser.apply(this, arguments);
}
export function Resetpassword() {
    var navigate = useNavigate();
    var _useState = _sliced_to_array(useState(""), 2), check1 = _useState[0], setCheck1 = _useState[1];
    var _useState1 = _sliced_to_array(useState(""), 2), check2 = _useState1[0], setCheck2 = _useState1[1];
    var _useState2 = _sliced_to_array(useState(""), 2), check3 = _useState2[0], setCheck3 = _useState2[1];
    var _useState3 = _sliced_to_array(useState(""), 2), check4 = _useState3[0], setCheck4 = _useState3[1];
    var _useState4 = _sliced_to_array(useState(""), 2), check5 = _useState4[0], setCheck5 = _useState4[1];
    var _useState5 = _sliced_to_array(useState(""), 2), check6 = _useState5[0], setCheck6 = _useState5[1];
    yup.addMethod(yup.string, "checkPassword", checkPasswordMethod);
    function checkPasswordMethod() {
        return this.test("checkPasswordTest", "", function(value) {
            var _this = this, path = _this.path, createError = _this.createError;
            if (Boolean(value)) {
                if (!/^(?=.{8,})/.test(value)) {
                    setCheck1("");
                } else {
                    setCheck1("active");
                }
                if (!/^[A-Za-z0-9!@#$%&]*$/.test(value)) {
                    setCheck2("");
                } else {
                    setCheck2("active");
                }
                if (!/^(?=.*[a-z])/.test(value)) {
                    setCheck3("");
                } else {
                    setCheck3("active");
                }
                if (!/^(?=.*[A-Z])/.test(value)) {
                    setCheck4("");
                } else {
                    setCheck4("active");
                }
                if (!/^(?=.*[0-9])/.test(value)) {
                    setCheck5("");
                } else {
                    setCheck5("active");
                }
                if (!/^(?=.*[!@#\$%\^&\*])/.test(value)) {
                    setCheck6("");
                } else {
                    setCheck6("active");
                }
                if (!/^(?=.{8,})/.test(value) || !/^(?=.*[a-z])/.test(value) || !/^(?=.*[A-Z])/.test(value) || !/^(?=.*[0-9])/.test(value) || !/^(?=.*[!@#\$%\^&\*])/.test(value)) {
                    return createError({
                        path: path,
                        message: "ตรวจสอบรหัสผ่าน"
                    });
                } else {
                    return true;
                }
            }
        });
    }
    ;
    var schema = yup.object().shape({
        password: yup.string().required("กรอกรหัสผ่าน").checkPassword(),
        confirmpassword: yup.string().oneOf([
            yup.ref("password"),
            null
        ], "รหัสผ่านไม่ตรงกัน")
    });
    var _useState6 = _sliced_to_array(useState("password"), 2), inputtype = _useState6[0], setInputtype = _useState6[1];
    var handleResetpassword = function() {
        var _ref = _async_to_generator(function(credentialResponse) {
            return _ts_generator(this, function(_state) {
                navigate("/reset/password/success");
                return [
                    2
                ];
            });
        });
        return function handleResetpassword(credentialResponse) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ _jsx("div", {
        className: "loginpage bg-white",
        children: /*#__PURE__*/ _jsxs(Row, {
            className: "g-0",
            children: [
                /*#__PURE__*/ _jsx(Col, {
                    lg: 7,
                    xl: 8,
                    className: "d-none d-xl-block",
                    children: /*#__PURE__*/ _jsx(Image, {
                        src: "/images/cover_login.png",
                        className: "w-100",
                        style: {
                            height: "100vh",
                            objectFit: "cover"
                        }
                    })
                }),
                /*#__PURE__*/ _jsx(Col, {
                    className: "d-flex justify-content-center align-items-center h-100vh",
                    children: /*#__PURE__*/ _jsx(Card, {
                        className: "box-login",
                        children: /*#__PURE__*/ _jsxs(Card.Body, {
                            className: "",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "text-center fs-20 fw-500 mb-4 tc-1",
                                    children: "กำหนดรหัสผ่านเพื่อเข้าสู่ระบบ"
                                }),
                                /*#__PURE__*/ _jsx(Formik, {
                                    initialValues: {
                                        username: "",
                                        password: "",
                                        remember: false
                                    },
                                    validationSchema: schema,
                                    onSubmit: function() {
                                        var _ref = _async_to_generator(function(values) {
                                            return _ts_generator(this, function(_state) {
                                                handleResetpassword(JSON.stringify(values, null, 2));
                                                return [
                                                    2
                                                ];
                                            });
                                        });
                                        return function(values) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }(),
                                    children: function(param) {
                                        var handleSubmit = param.handleSubmit, handleChange = param.handleChange, touched = param.touched, isValid = param.isValid, errors = param.errors, values = param.values;
                                        return /*#__PURE__*/ _jsxs(Form, {
                                            noValidate: true,
                                            onSubmit: handleSubmit,
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    name: "username",
                                                    placeholder: "อีเมลหรือเบอร์โทรศัพท์",
                                                    onChange: handleChange,
                                                    isValid: touched.username && !errors.username,
                                                    isInvalid: !!errors.username,
                                                    className: "form-st-1 mb-4",
                                                    value: "Wee_ra1999@mail.com",
                                                    disabled: true
                                                }),
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: "position-relative mb-4",
                                                    children: [
                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                            type: inputtype,
                                                            name: "password",
                                                            placeholder: "รหัสผ่าน",
                                                            onChange: handleChange,
                                                            isValid: touched.password && !errors.password,
                                                            isInvalid: !!errors.password,
                                                            className: "form-st-1 mb-3"
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "fs-14 text-danger",
                                                            children: errors.password
                                                        }),
                                                        /*#__PURE__*/ _jsx(Button, {
                                                            type: "button",
                                                            className: "btn btn-change-type-password",
                                                            onClick: function() {
                                                                return inputtype == "password" ? setInputtype("text") : setInputtype("password");
                                                            }
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: "position-relative mb-4",
                                                    children: [
                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                            type: inputtype,
                                                            name: "confirmpassword",
                                                            placeholder: "ยืนยันรหัสผ่าน",
                                                            onChange: handleChange,
                                                            isValid: touched.confirmpassword && !errors.confirmpassword,
                                                            isInvalid: !!errors.confirmpassword,
                                                            className: "form-st-1 mb-3"
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "fs-14 text-danger",
                                                            children: errors.confirmpassword
                                                        }),
                                                        /*#__PURE__*/ _jsx(Button, {
                                                            type: "button",
                                                            className: "btn btn-change-type-password",
                                                            onClick: function() {
                                                                return inputtype == "password" ? setInputtype("text") : setInputtype("password");
                                                            }
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs("ul", {
                                                    className: "checklistpassword",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("li", {
                                                            className: "".concat(check1),
                                                            children: "รหัสผ่านต้องมี 8-16 ตัวอักษร"
                                                        }),
                                                        /*#__PURE__*/ _jsx("li", {
                                                            className: "".concat(check2),
                                                            children: "รหัสผ่านต้องเป็นภาษาอังกฤษเท่านั้น"
                                                        }),
                                                        /*#__PURE__*/ _jsx("li", {
                                                            className: "".concat(check3),
                                                            children: "รหัสผ่านควรประกอบด้วยตัวพิมพ์เล็ก"
                                                        }),
                                                        /*#__PURE__*/ _jsx("li", {
                                                            className: "".concat(check4),
                                                            children: "รหัสผ่านควรประกอบด้วยตัวพิมพ์ใหญ่"
                                                        }),
                                                        /*#__PURE__*/ _jsx("li", {
                                                            className: "".concat(check5),
                                                            children: "รหัสผ่านควรประกอบด้วยตัวเลข"
                                                        }),
                                                        /*#__PURE__*/ _jsx("li", {
                                                            className: "".concat(check6),
                                                            children: "รหัสผ่านควรประกอบด้วยอักขระพิเศษ เช่น @ # - . เป็นต้น"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsx(Button, {
                                                    type: "submit",
                                                    className: "btn-login w-100 mb-4",
                                                    children: "ดำเนินการต่อ"
                                                })
                                            ]
                                        });
                                    }
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
}
export function Resetpasswordsuccess() {
    var navigate = useNavigate();
    return /*#__PURE__*/ _jsx("div", {
        className: "loginpage bg-white",
        children: /*#__PURE__*/ _jsxs(Row, {
            className: "g-0",
            children: [
                /*#__PURE__*/ _jsx(Col, {
                    lg: 7,
                    xl: 8,
                    className: "d-none d-xl-block",
                    children: /*#__PURE__*/ _jsx(Image, {
                        src: "/images/cover_login.png",
                        className: "w-100",
                        style: {
                            height: "100vh",
                            objectFit: "cover"
                        }
                    })
                }),
                /*#__PURE__*/ _jsx(Col, {
                    className: "d-flex justify-content-center align-items-center h-100vh",
                    children: /*#__PURE__*/ _jsx(Card, {
                        className: "box-login",
                        children: /*#__PURE__*/ _jsxs(Card.Body, {
                            className: "text-center",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: " text-center",
                                    children: /*#__PURE__*/ _jsx("div", {
                                        className: "icon-success mx-auto"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "text-center fs-24 fw-bold my-4 py-2",
                                    children: "เปลี่ยนรหัสผ่านสำเร็จ"
                                }),
                                /*#__PURE__*/ _jsx(Link, {
                                    to: "/login",
                                    className: "btn-login px-4 text-decoration-none mb-4",
                                    children: "เข้าสู่ระบบ"
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
}
